import { Result, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { errorHandler } from '../../../../utils';
import { instanceRef } from '../../../../utils/axios';

export default function AmpliacionFinalizacion(props) {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const update = async () => {
      try {
        setLoading(true);
        await updateInspeccion(props.inspeccion);
      } catch (err) {
        errorHandler(err);
      }
      setLoading(false);
    };
    update();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateInspeccion = (inspeccion) => {
    return instanceRef.instance.post(`inspeccion/update/${inspeccion.token}`, {
      estado: 'FOTOS_SUBIDAS',
      resultado: 'AMPLIACION'
    });
  };

  return (
    <div>
      {loading ? (
        <Spin />
      ) : (
        <Result
          status="success"
          title="¡Las fotografías fueron subidas exitosamente, gracias por realizar la Ampliación!"
        />
      )}
    </div>
  );
}
